import {GeneralMessageType} from './enums/general-message-type.enum';
import {GeneralMessage} from './general-message';

export class NoticeMessage extends GeneralMessage {
  constructor(title: string, payload: Object = {}) {
    super(title, GeneralMessageType.NOTICE, payload);
  }
}
